import { render } from "./UserTracks.vue?vue&type=template&id=3c84cc57&scoped=true&ts=true"
import script from "./UserTracks.vue?vue&type=script&lang=ts"
export * from "./UserTracks.vue?vue&type=script&lang=ts"

import "./UserTracks.vue?vue&type=style&index=0&id=3c84cc57&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c84cc57"]])

export default __exports__